import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showSnackbar } from "../../../api/snackbarSlice";
import { useDispatch } from "react-redux";
import { apiClient } from "../../../utils/axios";
import { useState } from "react";
import { AxiosError } from "axios";
import { isString } from "lodash";

export const mutateProduct = async ({ payload }) => {
  if (payload.id) {
    const { data } = await apiClient.put(`/products/${payload.id}`, payload);
    return data;
  }

  const { data } = await apiClient.post("/products", payload);
  return data;
};

export const useMutateProductHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutateProduct,
    onSuccess: (data, variables) => {
      dispatch(
        showSnackbar({
          message: "Product saved successfully.",
          severity: "success",
        }),
      );
      queryClient.invalidateQueries({ queryKey: ["products"] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response?.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(
          showSnackbar({
            message:
              error.response?.data?.message || "An unexpected error occurred",
            severity: "error",
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message)
              ? error.message
              : JSON.stringify(error.message),
            severity: "error",
          }),
        );
      }
    },
  });

  const onSubmit = async (payload, addOneMore) => {
    mutation.mutate({ payload, addOneMore });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
